module.exports = __webpack_public_path__ + "img/Döner.46cf4c5c.jpg";